module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "admin-page"
  }, [_vm._v("Platos de Comidas")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-fill pull-right",
    attrs: {
      "to": "/platoform"
    }
  }, [_vm._v("NUEVO PLATO")])], 1), _vm._v(" "), (_vm.platos.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.platos.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((Object.keys(_vm.categorias)), function(cat, idx) {
    return _c('li', {
      class: {
        active: _vm.categoriaActiva === cat
      },
      attrs: {
        "aria-controls": cat,
        "role": "tab",
        "data-toggle": "tab"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCategoriaActiva(cat)
        }
      }
    }, [_vm._v("\n              " + _vm._s(cat) + "\n            ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "role": "tabpanel",
      "id": "entradas"
    }
  }, [_c('div', {
    staticClass: "table-header form smart-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Búsqueda rápida"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-hover table-stripped table-no-first-pad"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(plato) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(plato.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(plato.descripcion))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_vm._m(3, true), _vm._v(" "), _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost js-editar",
      attrs: {
        "type": "button",
        "data-id": plato._id
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-pencil"
    })])]), _vm._v(" "), _vm._m(4, true)])])])
  }))])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center center-block placeholder"
  }, [_c('h1', [_vm._v("No tienes platos cargados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Descripcion")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "btn btn-xs btn-ghost",
    attrs: {
      "href": "",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-actions fa-eye"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "btn btn-xs btn-ghost",
    attrs: {
      "href": "",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-actions fa-times"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bfcc972"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Platos/Platos.vue
// module id = 1152
// module chunks = 5